import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" id=\"left\"><path fill-rule=\"evenodd\" d=\"M2.4 6l4.8-4.8L6 0 0 6l6 6 1.2-1.2L2.4 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron/left.svg
// module id = ./src/assets/icons/chevron/left.svg
// module chunks = 4